import PropTypes from "prop-types";
import styles from "./styles.module.css"
import { useIntl } from "react-intl";

export const DepentancyLogic = ({ configData }) => {
    const intl = useIntl();
    const renderValues = (data) => {

        return ['act_activate',
            'check_active',
            'act_inactivate',
            'check_inactive'].map((key) => {
                const values = data?.[key]
                return (
                    <div className={styles["row"]} key={key}>
                        <p className={`${styles["value"]} text-nowrap`}>
                            {key
                                .replaceAll("_", " ")
                                .replaceAll(/\b\w/g, (char) => char.toUpperCase())}
                            :
                        </p>

                        <p className={styles["value"]}>
                            {Array.isArray(values) && values.length > 0 ? values.join(", ") : "N/A"}
                        </p>
                    </div>
                )
            });
    };


    return (<div className={styles["container"]}>
        <div className={styles["wrapper"]}>
            <p className={styles["label"]}>{intl.formatMessage({
                id: "config.depentancy-logic.on-activate",
                defaultMessage: "On Activate",
            })}</p>
            {renderValues(configData?.on_activate)}
        </div>

        <div className={styles["breaker"]} />

        <div className={styles["wrapper"]}>
            <p className={styles["label"]}>{intl.formatMessage({
                id: "config.depentancy-logic.on-inactivate",
                defaultMessage: "On Inactivate",
            })}</p>
            {renderValues(configData?.on_inactivate)}
        </div>

        <div className={styles["breaker"]} />

        <div className={styles["wrapper"]}>
            <p className={styles["value"]}><b>{`${intl.formatMessage({
                id: "config.depentancy-logic.legal-basis",
                defaultMessage: "Legal Basis",
            })}: `}</b> {configData?.legal_basis || "N/A"}</p></div>
    </div>)
}

DepentancyLogic.propTypes = {
    configData: PropTypes.shape({
        on_activate: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
        on_inactivate: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
        legal_basis: PropTypes.string,
    }),
};